import React from 'react';
import ReportPageShell from './shared/ReportPageShell';

const TenderSummaryReport: React.FC = () => (
  <ReportPageShell
    reportType="tender-summary"
    title="Tender Summary"
    subtitle="Total paid per tender on completed sale transactions. A split-payment transaction counts as one transaction per tender."
    maxRangeDays={366}
    bullets={[
      'Tender Code',
      'Tender Name',
      'Type (Cash / Card / Discount)',
      'Transaction Count',
      'Total Amount',
    ]}
  />
);

export default TenderSummaryReport;
